import { AuthFormType, ClientType, PageType } from '../types';

export const clientTypeScope = (
  clientType: ClientType,
  formType: AuthFormType,
  pageType: PageType,
  setIsShownBackIcon: (isShown: boolean) => void,
  setIsShownCloseIcon: (isShown: boolean) => void,
) => {
  function giftPageClientScope() {
    setIsShownCloseIcon(false);
    switch (formType) {
      case AuthFormType.SetPhoneForConfirm:
        if (clientType === ClientType.UnconfEmailUnconfPhone)
          setIsShownBackIcon(false);
        break;
      default:
        setIsShownBackIcon(true);
    }
  }

  function feedbackPageClientScope() {
    setIsShownCloseIcon(false);
    switch (formType) {
      case AuthFormType.SetPhoneForConfirm:
        if (clientType === ClientType.UnconfEmailUnconfPhone)
          setIsShownBackIcon(false);
        break;
      default:
        setIsShownBackIcon(true);
    }
  }

  function checkoutPageClientScope() {
    setIsShownCloseIcon(false);
    switch (formType) {
      case AuthFormType.SetPhoneForConfirm:
        if (clientType === ClientType.UnconfEmailUnconfPhone)
          setIsShownBackIcon(false);
        break;
      default:
        setIsShownBackIcon(true);
    }
  }

  function defaultPageClientScope() {
    switch (formType) {
      case AuthFormType.SetPhoneForConfirm:
        if (clientType === ClientType.UnconfEmailUnconfPhone) {
          setIsShownBackIcon(false);
          setIsShownCloseIcon(true);
        } else if (clientType === ClientType.ConfEmailUnconfPhone) {
          setIsShownBackIcon(false);
          setIsShownCloseIcon(true);
        }
        break;
      case AuthFormType.ConfirmPhoneWithSMSCode:
        if (clientType === ClientType.UnconfEmailUnconfPhone) {
          setIsShownBackIcon(true);
          setIsShownCloseIcon(false);
        } else if (clientType === ClientType.ConfEmailUnconfPhone) {
          setIsShownBackIcon(true);
          setIsShownCloseIcon(true);
        }
        break;
      default:
        setIsShownBackIcon(true);
        setIsShownCloseIcon(true);
    }
  }

  switch (pageType) {
    case PageType.Gift:
      giftPageClientScope();
      break;
    case PageType.Checkout:
      checkoutPageClientScope();
      break;
    case PageType.Default:
      defaultPageClientScope();
      break;
    case PageType.Testimonials:
      feedbackPageClientScope();
      break;
    default:
  }
};
